<template>
  <div class="container">
    <div :class="{content: true, empty: list && list.length === 0}">
      <div :class="['clueList','myClue','top']">
        <div class="nav">
          <li v-for="(f, i) in filters" :key="i">
            <div class="status">
              <label>{{f.title}}</label>
              <span :class="{active: s.selected}" v-for="(s, si) in f.list" @click="choseStatus(s, f)" :key="si">{{s.title}}</span>
            </div>
          </li>
        </div>
      </div>
      <!-- 报道审核、我的报道样式 -->
      <div :class="{clueList: true, empty: list && list.length === 0, content: true}">
        <div class="nav">
          <!-- <li>
            <label @click="selectAll()"><img :src="allSelected ? icons.checkerOn: icons.checker" class="checker" alt="checker"></label>
            <button class="batch" @click="pushPatch()">批量发送</button>
          </li> -->
          <li class="upload creat" v-if="showCreate">
            <button @click="goCreate()">{{`新建${$_syscfg.report}`}}</button>
          </li>
        </div>
        <div class="list">
          <empty :mTop="30" v-if="list && list.length === 0" :msg="`暂无${$_syscfg.report}`" />
          <ul v-for="(item, index) in list" :key="index">
            <!-- <label @click="selectOne(item)"><img :src="item.selected ? icons.checkerOn : icons.checker" class="checker" alt="checker"></label> -->
            <img v-if="item.has_warning" src="@assets/img/common/warnTag.svg" alt="warn" class="warning">
            <div class="thumImg" @click="viewMedia(item)">
              <p class="tags" v-if="item.has_avid_icon || item.has_kankan_icon || item.has_iditor_icon">
                <img v-if="item.has_avid_icon" src="@assets/img/index/tv.svg" alt="tv">
                <img v-if="item.has_kankan_icon" src="@assets/img/index/kankan.svg" alt="kankan">
                <img v-if="item.has_iditor_icon" src="@assets/img/index/dxgg.svg" alt="dxgg">
              </p>
              <!-- <img @error="imgError(item)" class="cover" :src="item.img_url || (+item.play_icon==1?defaultAudioImg: defaultImg)" alt="img"> -->
              <img @error="imgError(item)" class="cover" :src="item.img_url || defaultImg" alt="img">
              <img v-if="item.play_icon==1 && item.img_url" class="play" src="@assets/img/index/play.svg" alt="play">
            </div>
            <dl class="reportContent">
              <a @click="handleGo(item)">
                <h4 :class="{news: item.is_new == 1}">
                  <span :class="{statusTag: true, greenTag: item.status == 0, redTag: item.status == 3, yellowTag: item.status == 1}"
                    v-if="item.status_name && item.status != 2">{{item.status_name}}</span>
                  <span class="title" :title="item.title">
                    {{item.title}}
                  </span>
                  <img src="@assets/img/common/tips.svg" alt="change" v-if="item.has_change - 0 === 1">
                  <img src="@assets/img/common/new.svg" alt="new" v-if="item.is_new - 0 === 1">
                  <img src="@assets/img/common/imgIcon.svg" alt="img" v-if="item.has_img - 0 === 1">
                  <img src="@assets/img/common/videoIcon.svg" alt="video" v-if="item.has_video - 0 === 1">
                  <img src="@assets/img/common/audioIcon.svg" alt="audio" v-if="item.has_sound - 0 === 1">
                  <!-- todo 22 -->
                  <img alt="技审未通过" title="技审未通过" class="verify-logo" v-if="item.has_audit&&item.has_audit==2" src="@assets/img/common/verify-fail.svg">
                </h4>
                <li>{{item.content}}</li>
              </a>
              <li class="smal">
                <span>{{item.user_name}}</span>
                <span>{{item.add_time}}</span>
                <span>
                  {{`被推送 ${item.push_list.length}`}}
                  <div class="pushlist" v-if="item.push_list.length > 0">
                    <p class="li" v-for="(pl, pli) in item.push_list" :key="pli">
                      <i class="title">{{pl.push_title}}</i>
                      <i>{{pl.user_name}}</i>
                      <i class="time">{{pl.raw_add_time}}</i>
                    </p>
                  </div>
                </span>
                <span @click="goViewLink(item)">{{item.view_num}}</span>
              </li>
            </dl>
            <!-- 我的报道 -->
            <div class="doubleCreat">
              <div class="line">
                <div class="line1" v-if="item.oneline">

                  <div>
                    <button class="success w2" v-if="item.has_copy" @click="copyReport(item.report_id)">转发</button>
                    <!-- <button v-if="item.has_push" class="success w3" @click="push(item.report_id)">发送至</button> 后台关掉了，如果放开需注意和送审功能的方法有冲突 -->
                    <button v-if="item.has_kankan" class="w3" @click="pushKK(item.report_id)">送看看</button>
                    <button class="w4" v-if="item.has_publish" @click="pushPublish(item.report_id, 'report')">{{`推送${$_syscfg.publish}`}}</button>
                    <button v-if="item.has_verify" class="success w2" @click="toCheck(item.report_id)">送审</button>
                    <button v-if="item.has_release" class="success w2" @click="publish(item.report_id)">发布</button>
                    <button v-if="item.has_update" class="w2" @click="goEdit(item.report_id)">更新</button>
                    <button v-if="item.has_edit" class="w2" @click="goEdit(item.report_id)">编辑</button>
                    <button v-if="item.has_del" class="w2" @click="deleteItem(item)">删除</button>
                  </div>
                </div>
                <div class="line2" v-else>
                  <div class="l1">
                    <button class="success w2" v-if="item.has_copy" @click="copyReport(item.report_id)">转发</button>
                    <!-- <button v-if="item.has_push" class="success w3" @click="push(item.report_id)">发送至</button> 后台关掉了，如果放开需注意和送审功能的方法有冲突 -->
                    <button v-if="item.has_kankan" class="w3" @click="pushKK(item.report_id)">送看看</button>
                    <button class="w4" v-if="item.has_publish" @click="pushPublish(item.report_id, 'report')">{{`推送${$_syscfg.publish}`}}</button>
                  </div>
                  <div class="l2">
                    <button v-if="item.has_verify" class="success w2" @click="toCheck(item.report_id)">送审</button>
                    <button v-if="item.has_release" class="success w2" @click="publish(item.report_id)">发布</button>
                    <button v-if="item.has_update" class="w2" @click="goEdit(item.report_id)">更新</button>
                    <button v-if="item.has_edit" class="w2" @click="goEdit(item.report_id)">编辑</button>
                    <button v-if="item.has_del" class="w2" @click="deleteItem(item)">删除</button>
                  </div>
                </div>
                <!-- <button class="success w2" v-if="item.has_copy" @click="copyReport(item.report_id)">转发</button> -->
                <!-- <button v-if="item.has_push" class="success w3" @click="push(item.report_id)">发送至</button> 后台关掉了，如果放开需注意和送审功能的方法有冲突 -->
                <!-- <button v-if="item.has_kankan" class="w3" @click="pushKK(item.report_id)">送看看</button>
                <button class="w4" v-if="item.has_publish" @click="pushPublish(item.report_id, 'report')">{{`推送${$_syscfg.publish}`}}</button>
                <button v-if="item.has_verify" class="success w2" @click="toCheck(item.report_id)">送审</button>
                <button v-if="item.has_release" class="success w2" @click="publish(item.report_id)">发布</button>
                <button v-if="item.has_update" class="w2" @click="goEdit(item.report_id)">更新</button>
                <button v-if="item.has_edit" class="w2" @click="goEdit(item.report_id)">编辑</button>
                <button v-if="item.has_del" class="w2" @click="deleteItem(item)">删除</button> -->
              </div>
              <!-- <div class="line">
                <button class="big" v-if="item.has_copy" @click="copyReport(item.report_id)">复制报道</button>
              </div> -->
            </div>
          </ul>
        </div>
        <pages :page_count="page.pageCount" :index="page.pageIndex" :total="page.total"></pages>
      </div>
    </div>
    <pushBox ref="pushBox" />
    <checkers ref="checkers" />
  </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import pages from "@components/pages";
import pushBox from "@components/pushBox";
import checkers from "@components/checkers";
import empty from "@components/empty";
import Vue from "vue";

export default {
  components: { pages, pushBox, checkers, empty },
  data() {
    return {
      isXnew: this.$store.state.isXnew,
      list: null,
      defaultImg: require("@assets/img/common/default.png"),
      defaultAudioImg: require("@assets/img/common/audioMask.png"),
      page: {
        pageCount: 0,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      allSelected: false,
      backShow: false,
      pushBox: false,
      icons: {
        checker: require("@assets/img/interview/checker.svg"),
        checkerOn: require("@assets/img/interview/checkerOn.svg")
      },
      filters: [],
      filterOptions: {},
      searchOptions: {},
      showCreate: false
    };
  },
  methods: {
    async pushPublish(id, t) {
      // 推送发布
      const type = await this.$pageType("publish");
      if (!type) return;

      const info = {
        subject_id: id,
        subject_type: t,
        type: type
      };

      common.myFetch(apis.publish_pushPublish, info).then(r => {
        if (r) {
          const url = `/editPublish?d=${r.id}`;

          common.jump(url, true);
        }
      });
    },
    imgError(i) {
      // 图片加载状态
      this.$set(i, "img_url", this.defaultImg);
    },
    async copyReport(id) {
      // 复制报道
      const type = await this.$pageType();
      if (!type) return;

      const info = {
        report_id: id,
        type: type
      };

      const newWindow = window.open();

      common.myFetch(apis.Rpt_copy, info).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editReport?d=${r.report_id}`;

          // common.jump(`/editReport?d=${r.report_id}`, true)
        }
      });
    },
    goViewLink(i) {
      if (i.url) {
        window.open(i.url);
      }
    },
    async viewMedia(item) {
      // 浏览稿件媒体
      common.openMaterialBox(null, null, false, item.report_id, 1);
      // common.viewMedia(null, null, false, item.report_id, 1)
    },
    async toCheck(id) {
      // this.$refs.checkers.open(id)
      // .then(res => {
      //   if (res) {
      //     this.getList()
      //   }
      // })

      const pushIds = await this.$refs.pushBox.open(id);
      if (pushIds === "cancel") return;

      const info = {
        report_id: id,
        push_id: pushIds
      };

      common.myFetch(apis.checker_add, info).then(r => {
        if (r) {
          this.$toast(r);
          this.getList();
        }
      });
    },
    async publish(id) {
      // 发布
      const pushIds = await this.$refs.pushBox.open(id);
      if (pushIds === "cancel") return;

      const info = {
        report_id: id,
        push_id: pushIds
      };

      common.myFetch(apis.Rpt_release, info).then(res => {
        if (res) {
          this.$toast(`${res.msg_one}，${res.msg_two}`);

          this.getList();
        }
      });
    },
    async deleteItem(i) {
      // let msg = `删除该${this.$_syscfg.report}？`;

      // const confirm = await this.$confirm(msg);
      // const confirm = await this.$confirmTitle({
      //   title: `确定删除该${this.$_syscfg.report}？`,
      //   msg: "同时删除关联素材，释放草稿空间",
      //   status: true
      // });
      let confirm = {};

      if(i.status == 0){
        confirm = await this.$confirmTitle({
          title: `确定删除该${this.$_syscfg.report}？`,
          msg: "同时删除关联素材，释放草稿空间",
          status: true,
          isCg: i.status == 0 ? true : false
        });
      }else{
        let msg = `删除该${this.$_syscfg.report}？`;

        confirm.status = await this.$confirm(msg);
        confirm.isSelected = 0;
      }
      
      if (!confirm.status) return;

      const info = {
        report_id: i.report_id,
        del_source: confirm.isSelected ? 1 : 0
      };

      common.myFetch(apis.deleteReport, info).then(r => {
        if (r) {
          this.$toast(r);
          this.getList();
        }
      });
    },
    selectAll() {
      // 全选／反选
      const pushlist = this.list.filter(l => {
        if (l.has_push) {
          return l;
        }
      });

      this.allSelected = !this.allSelected;

      pushlist.forEach(i => {
        this.$set(i, "selected", this.allSelected);
      });

      if (pushlist.length !== this.page.pageSize) {
        let msg = "已选中有发送权限的条目";
        if (pushlist.length === 0) {
          msg = "暂无可发送的条目";
        }

        this.$toast(msg);
        this.allSelected = false;
      }
    },
    selectOne(i) {
      // 选择／反选
      if (!i.has_push) {
        this.$toast("无发送权限，无法选中");
        return;
      }

      this.$set(i, "selected", !i.selected);

      this.$nextTick(() => {
        if (!i.selected) {
          this.allSelected = false;
        }
      });
    },
    getViewNum(info) {
      // 异步读取浏览数据并赋值
      common.myFetch(apis.Rpt_viewnum, info).then(r => {
        if (r) {
          const viewData = r.list;

          this.list.forEach(i => {
            if (viewData[i.idstring]) {
              this.$set(i, "view_num", viewData[i.idstring].count);
              this.$set(i, "link", viewData[i.idstring].url);
            }
          });
        }
      });
    },
    getList() {
      const id = this.$route.params.id;
      let info = {
        idstring: id,
        search_option: "",
        key_words: "",
        status: "",
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      };
      Object.assign(info, this.searchOptions, this.filterOptions);

      common.myFetch(apis.myreport, info).then(res => {
        this.allSelected = false;
        // this.list = res.list;
        // 控制按钮换行
        this.list = res.list.map(e => {
          let count = 0;
          if (e.has_copy) count++;
          if (e.has_kankan) count++;
          if (e.has_publish) count++;
          if (e.has_push) count++;
          e.oneline = count <= 1;
          return e;
        });
        // const info = {
        //   time_start: res.time_start,
        //   time_end: res.time_end
        // }
        // this.getViewNum(info)
        this.filters = res.params.list_search;
        this.generateSearchs(res.params.top_search.option.list);
        this.$set(
          this.page,
          "pageCount",
          common.calculatePage(res.page.row_count - 0, this.page.pageSize)
        );
        this.$set(this.page, "total", res.page.row_count - 0);
        this.showCreate = res.has_add_role;
      });
    },
    generateSearchs(data) {
      // 整理搜索栏数据
      const types = data.map(i => {
        return {
          name: i.title,
          code: i.key,
          selected: i.selected
        };
      });

      const filterData = {
        types: types,
        callback: o => {
          this.getSearch(o);
        }
      };
      this.postSearch(filterData);
    },
    getSearch(d) {
      // 接收搜索框数据
      this.searchOptions = d;
      this.page.pageIndex = 1;
      this.getList();
    },
    postSearch(data) {
      // 发送搜索框数据
      this.$emit("filterData", data);
    },
    choseStatus(i, l) {
      // 选择筛选项
      if (i.selected) return;

      this.page.pageIndex = 1;

      l.list.forEach(li => {
        li["selected"] = false;
      });

      this.$set(i, "selected", true);
      this.filterOptions[l.key] = i.key;
      this.getList();
    },
    async goCreate() {
      const type = await this.$pageType();
      if (!type) return;

      common.jump(`/creatReport?t=${type}`, true);
    },
    handleGo(i) {
      const s = i.status;
      this.$set(i, "has_change", 0);
      this.$set(i, "is_new", 0);

      if (s == 0 || s == 3) {
        this.goEdit(i.report_id);
      } else if (s == 1 || s == 2) {
        this.goDetail(i.report_id);
      }
    },
    async goEdit(id) {
      const newWindow = window.open();
      common.checkPageStatus(id, 1).then(r => {
        if (r) {
          newWindow.location.href = `${window.location.origin
            }/editReport?d=${id}`;
        } else {
          newWindow.close();
        }
      });
    },
    goDetail(id) {
      common.jump(`/reportDetail?d=${id}`, true);
    },
    push(id) {
      this.$refs.pushBox.open(id);
    },
    pushKK(id) {
      // const config = {
      //   msg: "是否添加knews套件？",
      //   alpha: {
      //     title: "添加",
      //     handle: () => {
      //       this.postKK(id, 1);
      //     }
      //   },
      //   beta: {
      //     title: "不添加",
      //     handle: () => {
      //       this.postKK(id, 0);
      //     }
      //   }
      // };

      // this.$ask(config);

      const config = {
        id: id
      }

      this.$kkType(config).then((res) => {
        if(res!=999){
          this.postKK(id, res)
        }
      })
    },
    postKK: (id, type) => {
      const info = {
        report_id: id,
        three: type
      };

      common.myFetch(apis.toKK, info).then(r => {
        if (r) {
          Vue.prototype.$toast(r);
        }
      });
    },
    pushPatch() {
      const ids = this.list
        .filter(i => {
          if (i.selected) {
            return i;
          }
        })
        .map(j => j.report_id)
        .join(",");
      if (!ids) {
        this.$toast("请至少选择一项");
        return;
      }

      this.push(ids);
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    this.getList();
  }
};
</script>

<style src="@assets/css/reportEditor/reportEditor.less" lang="less" scoped>
</style>
<style lang="less" scoped>
.container .content .clueList .list ul .doubleCreat div.line {
  // max-width: 190px;
  justify-content: flex-end;
  .l2 {
    text-align: right;
  }
  button {
    padding: 0;
    margin: 0;
    margin-left: 10px;
    margin-bottom: 10px;
    &.w2 {
      width: 40px;
    }
    &.w3 {
      width: 60px;
    }
    &.w4 {
      width: 70px;
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
.container .content .clueList .list ul .doubleCreat {
  padding-left: 90px;
}
</style>
